
export default {
	props: ['item','current'],
}
